module.exports = __webpack_public_path__ + "media/images/icon__facebook@3x-f1253c88dd2c4d0f5fa3b46da2c6d243.png";